<template>
  <div v-if="dataLoaded">
    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          icon="keyboard_backspace"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push(`/magazine`)"
        />
      </div>

      <div class="col-6">
        <q-btn
          class="capitalize ctrl-button right q-ml-md"
          :color="readOnly ? 'grey-5' : 'ctrl-turquoise'"
          :label="readOnly ? getString('action.edit') : getString('action.save')"
          @click="saveChanges()"
          :icon-right="readOnly ? 'edit' : 'save'"
        />
        <q-btn
          v-if="data.id"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          @click="deleteItem()"
          align="right"
        />
      </div>
    </div>

    <div class="row gutter-sm q-mb-lg">
      <!-- General Information -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">
          {{ getString(null, 'Details', 'Details') }}
        </p>
        <div class="card-block">
          <!-- Name -->
          <q-field
            class="q-mb-md"
            :error="$v.data.name.$dirty && !$v.data.name.required"
            :error-label="getString(null, 'Name is required', 'Naam is verplicht')"
          >
            <q-input
              type="text"
              @input="suggestUrl"
              v-model.trim="$v.data.name.$model"
              :disable="readOnly"
              :float-label="getString('name')"
            >
            </q-input>
          </q-field>
          <!-- Url -->
          <q-field
            class="q-mb-md"
            :error="$v.data.url.$dirty && !$v.data.url.required"
            :error-label="getString(null, 'Url is required', 'Url is verplicht')"
          >
            <q-input
              type="text"
              v-model.trim="$v.data.url.$model"
              :disable="readOnly"
              float-label="Url"
            >
            </q-input>
          </q-field>
          <!-- Active -->
          <q-field class="q-mb-md">
            <span class="q-mr-md">{{ getString('active') }}</span>
            <q-toggle color="secondary" type="text" v-model="data.active" :disable="readOnly">
            </q-toggle>
          </q-field>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 col-xs-12" v-if="$route.params.id">
        <p class="card-title">
          {{ getString(null, 'Editions', 'Uitgaven') }}
        </p>
        <div class="card-block">
          <div class="editions">
            <p v-if="!editions.length">
              {{
                getString(
                  null,
                  'There are no editions linked to the magazine yet',
                  'Er zijn nog geen uitgaven gekoppeld aan deze magazine'
                )
              }}
            </p>
            <div
              class="editions__row"
              v-for="edition in editions"
              :key="edition.isbn"
              @click="editionDetail(edition.id)"
            >
              {{ edition.name }}
            </div>
          </div>
          <q-btn
            class="capitalize ctrl-button"
            color="primary"
            icon="add"
            :label="getString('action.add')"
            @click="editionDetail()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import saveChanges from '@/mixins/detailViews/saveChanges';
import suggestUrl from '@/mixins/suggestUrl';
import getString from '@/helpers/GetStrings';

export default {
  validations: {
    data: {
      name: {
        required,
      },
      url: {
        required,
      },
    },
  },
  data() {
    return {
      successMessage: this.getString(
        null,
        'The magazine has been saved',
        'Het magazine is succesvol opgeslagen',
      ),
      validationsChecked: false,
      dataLoaded: false,
      endpoint: 'magazine',
      responseData: {
        multiple: 'magazines',
        single: 'magazine',
      },
      module: 'magazine',
      data: {
        name: '',
        url: '',
        active: true,
      },
      editions: [],
    };
  },

  mixins: [suggestUrl, saveChanges],
  methods: {
    getString,

    editionDetail(id = null) {
      this.$router.push(`/magazine/${this.$route.params.id}/edition/${id || 'add'}`);
    },

    requestParams() {
      return {
        name: this.data.name,
        url: this.data.url,
        active: Number(this.data.active),
      };
    },

    getEditions() {
      this.axios
        .get(`magazine/${this.$route.params.id}/edition`)
        .then((res) => {
          console.log(res);
          this.editions = res.data.editions;
        })
        .catch(() => {
          console.warn('No editions found for this request');
        });
    },

    deleteItem() {
      // Dialog
      this.$q
        .dialog({
          title: '',
          message: this.getString('module.library.delete.title.single'),
          ok: this.$store.state.stringsStore.strings.dialog.confirm.ok,
          cancel: this.$store.state.stringsStore.strings.dialog.confirm.cancel,
        })
        .then(() => {
          // delete call
          this.axios
            .delete(`magazine/${this.data.id}`)
            .then(() => {
              // Refresh data to see the result
              this.$q.notify({
                message: this.getString('upload.delete.success').replace(
                  '%file%',
                  this.getString('magazine'),
                ),
                position: 'top-right',
                timeout: 1000,
                color: 'positive',
              });
              this.$router.push('/magazine');
            })
            .catch((error) => {
              // Error
              console.warn(error);
            });
        })
        .catch(() => {
          console.warn('Not removed');
        });
    },
  },

  mounted() {
    if (this.$route.params.id) this.readOnly = true;
  },

  created() {
    if (this.$route.params.id) {
      // Fetch the selected module details by id.
      this.axios
        .get(`magazine/${this.$route.params.id}`)
        .then(async (response) => {
          // In the module detail page, if a given id is not found, we will always get a 200 OK response.
          if (!response.data.magazine) {
            // Redirect to modules overview
            this.$router.push('/magazine');
            return;
          }

          this.data = response.data.magazine;

          await this.getEditions();

          console.log(this.data);

          this.dataLoaded = true;
        })
        .catch((error) => {
          console.warn(error);

          // Notify if nothing found
          if (error.response.status === 404) {
            this.$q.notify({
              message: getString(`module.${this.module}.edit.error.nothingFound`),
              type: 'warning',
              timeout: 2000,
              position: 'top-right',
            });
          } else {
            // Throw general error notification
            this.$q.notify({
              message: getString('error.general'),
              position: 'top-right',
              timeout: 1000,
              type: 'warning',
            });
          }

          // Redirect to modules overview
          this.$router.push(`/${this.module}`);
        });
    } else {
      // Nothing to load
      this.dataLoaded = true;
    }
  },
};
</script>

<style lang="stylus" scoped>
  @import '~variables';
  .data-title
    font-weight 700

  .data-content
    word-break break-all

.editions
  margin-bottom 10px
  &__row
    padding 10px
    cursor pointer
    background $ctrl-grey-lighten-2
    border-radius 5px
    border 1px solid $ctrl-grey
    margin-bottom 5px
    &:hover
      background $ctrl-grey-lighten-1
</style>
